import React, {useContext} from 'react';
import UIInput from '../../../ui/form/UIInput';
import {FormTypeContext} from '../types';

/**
 * Renders a field label input for a custom field
 * @constructor
 */
export default function FieldLabel() {
  const formTypeContext = useContext(FormTypeContext);
  return (
    <UIInput id="label" name="label" label={`${formTypeContext.capitalizeToken()} label`} className="mb-2"
      tooltip={<div className="w-48">Workshop Butler uses the {formTypeContext.token} label to produce reports or show
                                     data inside the system. Your customers do not see it</div>}
    />
  );
}
